import { cn } from './cn';

/**
 * The shape of every pick-one-of-a-few control in the product: FleetSight's
 * pill. A white track with a hairline, the options as pills inside it, the
 * chosen one on `--muted`. It scrolls sideways rather than wrapping when the
 * options outgrow a phone.
 *
 * Kept as class strings rather than a component because the two callers differ
 * in markup, not in looks: `SegmentedControl` is a `radiogroup` of `radio`s and
 * `Tabs` is a `tablist` of `tab`s.
 */

export type SegmentedSize = 'sm' | 'md';

/** The track. */
export function segmentedTrack(_size: SegmentedSize = 'md', className?: string) {
  return cn(
    'inline-flex max-w-full items-center gap-0.5 overflow-x-auto rounded-full border border-border bg-card p-0.5 no-scrollbar',
    className
  );
}

/** One option. */
export function segmentedItem(selected: boolean, size: SegmentedSize = 'md', className?: string) {
  return cn(
    'inline-flex min-w-0 shrink-0 items-center justify-center gap-1.5 rounded-full font-medium whitespace-nowrap',
    'transition-colors duration-150',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
    'disabled:pointer-events-none disabled:opacity-50',
    size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
    selected ? 'bg-muted text-foreground' : 'text-muted-foreground hover:text-foreground',
    className
  );
}
